import { render } from "./analysisSystem.vue?vue&type=template&id=6cf2f4b0&scoped=true"
import script from "./analysisSystem.vue?vue&type=script&lang=js"
export * from "./analysisSystem.vue?vue&type=script&lang=js"

import "./analysisSystem.vue?vue&type=style&index=0&id=6cf2f4b0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6cf2f4b0"

export default script